import { createTheme } from '@mui/material/styles';

export const popinaTheme = () =>
  createTheme({
    palette: {
      primary: {
        main: "#474F5E",
        light: "#FFFFFF",
      },
      secondary: {
        main: "#7ABF92",
      },
      error: {
        main: "#FFFFFF",
      },
    },
  });

export const jaliaTheme = () =>
  createTheme({
    palette: {
      primary: {
        main: "#072c3d",
        light: "#FFFFFF",
      },
      secondary: {
        main: "#ffd400"
      },
      error: {
        main: "#FFFFFF"
      }
    }
  })
